/* eslint-disable no-magic-numbers */
import { Injectable } from '@tanbo/vue-di-plugin'
import { Http } from '@/services/http'

import { InvokeThrottle } from '@/common/decorators/invoke-throttle'

import { defaultErrorAction, errorKeyMap } from '@/common/error/error-code'
import { ElMessage } from 'element-plus'
import { i18n } from '@/i18n'

const DAY_SEC = 3600 * 24
const HOUR_SEC = 3600
const MIN_SEC = 60
@Injectable()
export class ServiceInfoService {
  constructor (private http: Http) {
  }

  @InvokeThrottle()
  updateUninstallCode (code: string) {
    return this.http.post('/team/update-uninstallcode', {
      code
    }).catch(error => {
      if (error.responseBody?.ret === errorKeyMap.ILLEGAL_PARAMETER.ret) {
        ElMessage.error(i18n.global.t('teamInfoEdit.uninstallPasswordLengthExceeded'))
      } else {
        defaultErrorAction(error)
      }
    })
  }

  @InvokeThrottle()
  updateExitCode (code: string) {
    return this.http.post('/team/update-exitcode', {
      code
    }).catch(error => {
      if (error.responseBody?.ret === errorKeyMap.ILLEGAL_PARAMETER.ret) {
        ElMessage.error(i18n.global.t('teamInfoEdit.exitPasswordLengthExceeded'))
      } else {
        defaultErrorAction(error)
      }
    })
  }
}

function calcOnlineTime (duration: number) {
  let outStr = ''
  if (duration > 0) {
    const hours = Math.floor(duration / HOUR_SEC)
    const minutes = Math.floor((duration % HOUR_SEC) / MIN_SEC)
    if (hours) {
      outStr += i18n.global.t('serviceInfo.durationHours', { n: hours })
    }
    if (minutes) {
      outStr += i18n.global.t('serviceInfo.durationMinutes', { n: minutes })
    }
    // outStr += (duration % HOUR_SEC) % MIN_SEC ? +(duration % HOUR_SEC) % MIN_SEC + '秒' : ''
    return outStr
  }
}
export function formatDayRemain (now: number, expires: number) {
  const remain = expires - now
  if (remain <= 0) {
    return i18n.global.t('serviceInfo.expired')
  }
  if ((remain / 1000) < DAY_SEC) {
    return calcOnlineTime(remain / 1000)
  }
  // eslint-disable-next-line no-magic-numbers
  return (remain / (24 * 60 * 60 * 1000)).toFixed(0)
}

export function parseDayRemain (now: number, expires: number) {
  const remain = expires - now
  if (remain < 0) {
    return 0
  }

  // eslint-disable-next-line no-magic-numbers
  return (remain / (24 * 60 * 60 * 1000)).toFixed(0)
}
